import { useEffect, useState, useCallback } from 'react';
import { Box, Table, Sheet } from '@mui/joy';
import { APIFinanceSurveysBreakdown } from '../../../api';
import {
  useFinanceToken, PeriodBar, MetricCard, MetricGrid, SectionCard, scrollTableSx,
  fmtMoney, fmtNum, todayISO, monthStartISO,
} from './financeShared';

function BreakdownTable({ title, rows, nameCol }) {
  return (
    <SectionCard title={title}>
      <Sheet variant="outlined" sx={{ borderRadius: 'lg', overflow: 'auto' }}>
        <Table borderAxis="both" stickyHeader hoverRow size="sm" sx={scrollTableSx(560)}>
          <thead>
            <tr>
              <th>{nameCol}</th>
              <th style={{ width: 110, textAlign: 'center' }}>Замеров</th>
              <th style={{ width: 140, textAlign: 'right' }}>Начислено</th>
              <th style={{ width: 140, textAlign: 'right' }}>Выплачено</th>
              <th style={{ width: 140, textAlign: 'right' }}>Остаток</th>
            </tr>
          </thead>
          <tbody>
            {(rows || []).map((r, i) => (
              <tr key={r.id ?? r.city_id ?? i}>
                <td>{r.name}</td>
                <td style={{ textAlign: 'center' }}>{fmtNum(r.measurements)}</td>
                <td style={{ textAlign: 'right' }}>{fmtMoney(r.accrued)}</td>
                <td style={{ textAlign: 'right' }}>{fmtMoney(r.paid)}</td>
                <td style={{ textAlign: 'right', fontWeight: 600, color: r.outstanding > 0 ? '#b45309' : undefined }}>{fmtMoney(r.outstanding)}</td>
              </tr>
            ))}
            {(!rows || rows.length === 0) && <tr><td colSpan={5} style={{ textAlign: 'center', color: '#94a3b8' }}>Нет данных</td></tr>}
          </tbody>
        </Table>
      </Sheet>
    </SectionCard>
  );
}

export default function FinanceSurveysTab() {
  const token = useFinanceToken();
  const [dateFrom, setDateFrom] = useState(monthStartISO());
  const [dateTo, setDateTo] = useState(todayISO());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(() => {
    if (!token) return;
    setLoading(true);
    APIFinanceSurveysBreakdown({ date_from: dateFrom, date_to: dateTo }, token)
      .then(setData).catch((e) => console.error('surveys', e)).finally(() => setLoading(false));
  }, [token, dateFrom, dateTo]);
  useEffect(() => { load(); }, [load]);

  return (
    <Box>
      <PeriodBar
        from={dateFrom} to={dateTo}
        onFrom={setDateFrom} onTo={setDateTo}
        onPreset={(f, tt) => { setDateFrom(f); setDateTo(tt); }}
        loading={loading}
      />

      <MetricGrid>
        <MetricCard index={0} title="Всего замеров" value={fmtNum(data?.total_measurements)} color="#0ea5e9" />
        <MetricCard index={1} title="Из них от клиентов" value={fmtNum(data?.client_measurements)} color="#8b5cf6" />
      </MetricGrid>

      <BreakdownTable title="По обмерщикам" rows={data?.by_surveyor} nameCol="Обмерщик" />
      <BreakdownTable title="По чертёжникам" rows={data?.by_draftsman} nameCol="Чертёжник" />
      <BreakdownTable title="По городам" rows={data?.by_city} nameCol="Город" />
    </Box>
  );
}